import { Envelope } from 'types';

export const getEnvelopeDetailsUrl = (envelope: Envelope): string =>
  `/firmas/${envelope.society}/${envelope._id}`;

export const getEnvelopeSignUrl = (
  envelope: Envelope,
  signerId: string
): string => `/firma-sobre/${envelope.society}/${envelope._id}/${signerId}`;

export const getEnvelopeDetailsUrlByRole = (
  envelope: Envelope,
  isAdmin: boolean,
  isDirector?: boolean,
  signerId?: string
): string => {
  if (isAdmin) {
    return getEnvelopeDetailsUrl(envelope);
  }

  if (signerId) {
    return getEnvelopeSignUrl(envelope, signerId);
  }

  return '';
};
